import React, { useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "reducers/notificationReducer";

import { notificationTypes } from "constants/notificationTypes";
import { socketContext } from "contexts/SocketContext";

import { Link } from "react-router-dom";
import { Button, Feed, Icon, Portal, Reveal, Segment } from "semantic-ui-react";
import { formatDistance } from "date-fns";

function NotificationButton() {
	const { unread } = useSelector((state) => state.notifications);

	const dispatch = useDispatch();
	const socket = useContext(socketContext);

	// listeners
	socket?.on(notificationTypes.STOCKALERT, (data) => {
		dispatch(notificationActions.addUnread(data));
	});
	socket?.on(notificationTypes.MARKEDASREAD, (id) => {
		dispatch(notificationActions.markAsRead(id));
	});

	// action
	const markAsRead = (_id) => {
		socket.emit("markAsRead", _id);
	};

	return (
		<Portal
			closeOnDocumentClick
			closeOnEscape
			closeOnTriggerClick
			openOnTriggerClick
			trigger={
				<Button
					circular
					basic
					compact
					size="tiny"
					style={{
						position: "relative",
						paddingRight: `${
							unread?.length < 10
								? 18
								: unread?.length < 100
								? 25
								: 15
						}px`,
					}}
					color={unread?.length ? "red" : "grey"}
				>
					<Icon name="bell" />
					<span
						style={{
							position: "absolute",
							fontWeight: "bolder",
							fontSize: "14px",
						}}
					>
						{unread?.length}
					</span>
				</Button>
			}
		>
			<Segment
				style={{
					left: "14%",
					position: "fixed",
					top: "35px",
					zIndex: 1000,
					maxWidth: "400px",
				}}
			>
				<Feed>
					{!unread.length ? (
						<Feed.Event content="No unread alerts." />
					) : null}
					{unread?.map((item) => (
						<Feed.Event key={item._id}>
							<Feed.Label>
								<Reveal animated="fade">
									<Reveal.Content visible>
										<Icon
											onClick={() => markAsRead(item._id)}
											name={
												item.state === "unread"
													? "question circle"
													: "bell"
											}
											style={{
												cursor: "pointer",
												backgroundColor: "white",
											}}
										/>
									</Reveal.Content>
									<Reveal.Content hidden>
										<Icon name={"check"} />
									</Reveal.Content>
								</Reveal>
							</Feed.Label>
							<Feed.Content style={{ marginTop: 0 }}>
								<Link to={item.link}>
									<Feed.Summary>
										<p
											style={{
												lineHeight: 1.2,
												marginBottom: "5px",
												marginTop: "0px",
											}}
										>
											{item.message}
										</p>
									</Feed.Summary>
								</Link>
								<Feed.Date>
									{formatDistance(
										new Date(item.date),
										Date.now()
									)}
								</Feed.Date>
							</Feed.Content>
						</Feed.Event>
					))}
				</Feed>
			</Segment>
		</Portal>
	);
}

export default NotificationButton;
